const DEBOUNCE_MS = 1000;
const MAX_BATCH = 50;

class BrowserLogger {
  constructor() {
    this.ctx = { negotiationId: null, userId: null, traceId: null };
    this.queue = [];
    this.flushTimer = null;
  }

  setNegotiationId(id) {
    this.ctx.negotiationId = id;
  }
  setTraceId(id) {
    this.ctx.traceId = id;
  }
  setUserId(id) {
    this.ctx.userId = id;
  }
  clearContext() {
    this.ctx = { negotiationId: null, userId: null, traceId: null };
  }

  debug(event, payload) {
    this._emit('debug', event, payload);
  }
  info(event, payload) {
    this._emit('info', event, payload);
  }
  warn(event, payload) {
    this._emit('warn', event, payload);
  }
  error(event, payload) {
    this._emit('error', event, payload);
  }

  _emit(level, event, payload) {
    const entry = {
      timestamp: new Date().toISOString(),
      level,
      event,
      ctx: { ...this.ctx },
      payload: payload ?? {},
    };
    if (level === 'error') console.error(entry);
    else console.debug(entry);
    if (this._isDebugMode()) {
      this.queue.push(entry);
      this._scheduleFlush();
    }
  }

  _isDebugMode() {
    const url = new URLSearchParams(window.location.search);
    if (url.get('debug') === '1') {
      localStorage.setItem('debugMode', 'true');
      return true;
    }
    if (url.get('debug') === '0') {
      localStorage.removeItem('debugMode');
      return false;
    }
    return localStorage.getItem('debugMode') === 'true';
  }

  _scheduleFlush() {
    if (this.flushTimer) return;
    this.flushTimer = setTimeout(() => this._flush(), DEBOUNCE_MS);
  }

  async _flush() {
    this.flushTimer = null;
    const batch = this.queue.splice(0, MAX_BATCH);
    if (batch.length === 0) return;
    for (const entry of batch) {
      try {
        await fetch('/api/debug/frontend-log', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            traceId: entry.ctx.traceId ?? undefined,
            negotiationId: entry.ctx.negotiationId,
            level: entry.level,
            event: entry.event,
            payload: { ...entry.payload, _ctx: entry.ctx },
          }),
        });
      } catch {
        // best-effort; do not retry
      }
    }
    if (this.queue.length > 0) this._scheduleFlush();
  }
}

export const browserLogger = new BrowserLogger();
export const _resetForTests = () => {
  browserLogger.clearContext();
  browserLogger.queue = [];
  if (browserLogger.flushTimer) {
    clearTimeout(browserLogger.flushTimer);
    browserLogger.flushTimer = null;
  }
};
